import React, { Fragment } from "react";
import { INaeTab } from "@newageerp/nae-react-ui/dist/interfaces";


export const NaeTabs: INaeTab[] = [

];